import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchinline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "currentColor",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", { d: "M6 0a6 6 0 014.891 9.476L15.414 14 14 15.414l-4.524-4.523A6 6 0 116 0zm0 2a4 4 0 100 8 4 4 0 000-8z" })
	})
});
export default SvgSearchinline;
